import { useEffect, useState } from "react";

// Current time in ms, refreshed every `intervalMs` so elapsed-time labels stay
// current without reading the clock during render.
export function useNow(intervalMs = 60_000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
